import PropTypes from 'prop-types';
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Admin from 'react/signups/card/modules/admin/Admin';
import CardOrder from 'react/signups/card/modules/card_order/CardOrder';
import Credentials from 'react/signups/card/modules/credentials/Credentials';
import Idv from 'react/signups/card/modules/idv/Idv';
import Review from 'react/signups/card/modules/review/Review';
import Shipping from 'react/signups/card/modules/shipping/Shipping';
import Survey from 'react/signups/card/modules/survey/Survey';
import Trust from 'react/signups/card/modules/trust/Trust';
import { MODULES } from 'react/signups/card/recipes/constants';
import cardAccountSignupShape from 'react/signups/card/shapes/CardAccountSignup';
import cardAccountTrustShape from 'react/signups/card/shapes/CardAccountTrust';
import cardProgramQuestionsShape from 'react/signups/card/shapes/CardProgramQuestions';
import currentModuleShape from 'react/signups/card/shapes/CurrentModule';
import organizationShape from 'react/signups/card/shapes/Organization';
import recipeShape from 'react/signups/card/shapes/Recipe';
import userShape from 'react/signups/card/shapes/User';

export default function SignupRoutes({
  account,
  cardAccountSignup,
  cardAccountTrust,
  cardProgramQuestions,
  cookbook,
  currentModule,
  organization,
  setAccount,
  setCardAccountSignup,
  setCardAccountTrust,
  setCardProgramQuestions,
  setUser,
  setOrganization,
  user,
  setMdWidthCard,
}) {
  // Force anyone back to the survey if we don't have a userType
  if (currentModule !== MODULES.SURVEY && cardAccountSignup.userType === '') {
    return <Navigate replace to={{ pathname: cookbook.defaultPath }} />;
  }

  let redirectPath = cookbook.defaultPath;
  if (cardAccountSignup.resumePage) {
    const resumeModule = cardAccountSignup.resumePage.split('/')[1];
    redirectPath = `/${resumeModule}`;
  }

  const admin = (
    <Admin
      cardAccountSignup={cardAccountSignup}
      organization={organization}
      recipe={cookbook.recipes[MODULES.ADMIN]}
      setCardAccountSignup={setCardAccountSignup}
      setOrganization={setOrganization}
      setUser={setUser}
      user={user}
    />
  );

  const credentials = (
    <Credentials
      cardAccountSignup={cardAccountSignup}
      recipe={cookbook.recipes[MODULES.CREDENTIALS]}
      setCardAccountSignup={setCardAccountSignup}
      setUser={setUser}
      user={user}
    />
  );

  const cardOrder = (
    <CardOrder
      account={account}
      cardAccountSignup={cardAccountSignup}
      cardProgramQuestions={cardProgramQuestions}
      organization={organization}
      recipe={cookbook.recipes[MODULES.CARD_ORDER]}
      setAccount={setAccount}
      setCardProgramQuestions={setCardProgramQuestions}
      user={user}
    />
  );

  const shipping = (
    <Shipping
      account={account}
      cardAccountSignup={cardAccountSignup}
      organization={organization}
      recipe={cookbook.recipes[MODULES.SHIPPING]}
      setAccount={setAccount}
    />
  );

  const idv = (
    <Idv
      account={account}
      cardAccountSignup={cardAccountSignup}
      cardAccountTrust={cardAccountTrust}
      organization={organization}
      recipe={cookbook.recipes[MODULES.IDV]}
      setUser={setUser}
      user={user}
    />
  );

  const review = (
    <Review
      account={account}
      cardAccountSignup={cardAccountSignup}
      cardAccountTrust={cardAccountTrust}
      cardProgramQuestions={cardProgramQuestions}
      organization={organization}
      recipe={cookbook.recipes[MODULES.REVIEW]}
      setAccount={setAccount}
      setOrganization={setOrganization}
      user={user}
    />
  );

  const survey = (
    <Survey
      cardAccountSignup={cardAccountSignup}
      recipe={cookbook.recipes[MODULES.SURVEY]}
      setCardAccountSignup={setCardAccountSignup}
      setMdWidthCard={setMdWidthCard}
    />
  );

  const trust = (
    <Trust
      account={account}
      cardAccountSignup={cardAccountSignup}
      cardAccountTrust={cardAccountTrust}
      organization={organization}
      recipe={cookbook.recipes[MODULES.TRUST]}
      setAccount={setAccount}
      setCardAccountTrust={setCardAccountTrust}
      user={user}
    />
  );

  return (
    <Routes>
      <Route element={admin} path="/admin/*" />
      <Route element={credentials} path="/account/*" />
      <Route element={cardOrder} path="/card_order/*" />
      <Route element={shipping} path="/shipping/*" />
      <Route element={idv} path="/idv/*" />
      <Route element={review} path="/review/*" />
      <Route element={survey} path="/survey/*" />
      <Route element={trust} path="/trust/*" />
      <Route element={<Navigate replace to={redirectPath} />} path="/*" />
    </Routes>
  );
}

SignupRoutes.propTypes = {
  account: PropTypes.object,
  cookbook: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultPath: PropTypes.string.isRequired,
    recipes: PropTypes.objectOf(recipeShape).isRequired,
  }).isRequired,
  cardAccountSignup: cardAccountSignupShape,
  cardAccountTrust: cardAccountTrustShape,
  cardProgramQuestions: cardProgramQuestionsShape,
  currentModule: currentModuleShape.isRequired,
  organization: organizationShape,
  user: userShape,
  setAccount: PropTypes.func,
  setCardAccountSignup: PropTypes.func.isRequired,
  setCardAccountTrust: PropTypes.func.isRequired,
  setCardProgramQuestions: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
  setOrganization: PropTypes.func.isRequired,
  setMdWidthCard: PropTypes.func,
};
